import type { AlternativePlan } from "@Light/services/lightTypes";
import clsx from "clsx";
import { motion } from "motion/react";

export type AlternativePlansProps = {
  alternativePlans: AlternativePlan[];
  onSelect: (alternativePlan: AlternativePlan) => void;
  variant: "main" | "sidebar";
};

export const AlternativePlans = ({
  alternativePlans,
  onSelect,
  variant,
}: AlternativePlansProps) => (
  <motion.div
    initial={{ opacity: 0, y: 4 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -4 }}
    transition={{ duration: 0.15, ease: "easeOut" }}
    className={clsx(
      "flex-col gap-lg text-tertiary",
      variant === "main"
        ? "flex w-full max-w-90 text-sm font-medium text-center expanded:hidden"
        : "hidden px-lg text-xs expanded:flex",
    )}
    data-testid={`alternative-plans-${variant}`}
  >
    {alternativePlans.map((alternativePlan) => (
      <div
        key={alternativePlan.plan_group_uuid}
        className={clsx("flex flex-col", variant === "sidebar" && "gap-xs")}
      >
        <div className={clsx(variant === "sidebar" && "font-medium")}>
          {alternativePlan.suggestion_text}
        </div>
        <button
          className={clsx(
            "underline",
            variant === "main" ? "self-center" : "self-start",
          )}
          onClick={() => {
            onSelect(alternativePlan);
          }}
        >
          {alternativePlan.action_text}
        </button>
      </div>
    ))}
  </motion.div>
);
